<script>
import { VBTooltip } from 'bootstrap-vue';
import dayjs from '../../core/dayjs';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },

  props: {
    user: String,
  },

  data () {
    return {
      created: [],
      completed: [],
      history: [],
      loading: {
        created: true,
        completed: true,
        history: true,
      },
    };
  },

  computed: {
    activityOptions () {
      const {
        __,
      } = this;
      const now = dayjs();

      return [
        {
          name: __('Hoje'),
          value: now.startOf('day').format('INTL'),
        },
        {
          name: __('Últimos 7 dias'),
          value: now.subtract(7, 'days').startOf('mmon').format('INTL'),
        },
        {
          name: __('Este mês'),
          value: now.startOf('month').format('INTL'),
        },
        {
          name: 'Todas',
          value: null,
        },
      ];
    },
  },

  methods: {
    fetchActivities (from = null, completed = false) {
      const params = {
        completed: completed | 0,
      };

      if (from !== false) {
        params.from = from;
      }

      return this.$http.get(`/user/${this.user}/activity`, {
        params,
      });
    },

    fetchHistory () {
      this.loading.history = true;

      this.fetchActivities(false, null)
        .then(({ data: activities }) => this.history = activities)
        .finally(() => this.loading.history = false);
    },

    fetchCreated (option) {
      this.loading.created = true;

      this.fetchActivities(option.value)
        .then(({ data: activities }) => this.created = activities)
        .finally(() => this.loading.created = false);
    },

    fetchCompleted (option) {
      this.loading.completed = true;

      this.fetchActivities(option.value, true)
        .then(({ data: activities }) => this.completed = activities)
        .finally(() => this.loading.completed = false);
    },
  },
};
</script>
